import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface UseBulkActionsEntryConfirmProps {
  entryId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

export const useBulkActionsEntryConfirm = ({
  entryId,
  onSuccess,
  onError,
}: UseBulkActionsEntryConfirmProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['bulkActionsEntryConfirm', entryId],
    mutationFn: () => {
      return privateAxios.put(`/bulk_actions/entries/${entryId}/confirm`);
    },
    onSuccess,
    onError,
  });
};
